import ContentGatingBannerFactory from 'shared/components/content_gating/content_gating_banner_factory';
import Topic from 'shared/topic';
import KmklabsUtil from 'shared/kmklabs_util';
import AhoyEvent from 'shared/ahoy_event';

export default class ContentGatingBanner {
  constructor(currentUser) {
    this.currentUser = currentUser;
  }

  init() {
    this._disposeCounter = 0;
    this._disposeIntervalId = null;

    this.banner = ContentGatingBannerFactory.getInstance(this.currentUser, this.contentType);
    if(this.banner) {
      this.initOrSubscribeBanner();
    }
  }

  initOrSubscribeBanner() {
    if (window.player != undefined) {
      this.initBanner();
    } else {
      Topic.subscribeOnce('player/ready', this.initBanner.bind(this));
      Topic.subscribeOnce('player/player/loaded', this.initBanner.bind(this));
    }
  }

  initBanner(){
    if (window.contentGatingActionRequiredAfter === undefined || window.contentGatingActionRequiredAfter === 0) {
      this.showBanner();
    } else {
      const initBannerInterval = setInterval(() => {
        if (Object.keys(window.player.tech()).length != 0) {
          clearInterval(initBannerInterval);
          this.addEventTimeUpdate();
        }
      }, 100);
    }
  }

  addEventTimeUpdate() {
    window.player.tech().on(
      'timeupdate',
      this.showContentGatingIfPlayLimitExceeded.bind(this)
    );
  }

  storeInitialPlayerTime() {
    if (!this.initialPlayerTime) {
      this.initialPlayerTime = window.player.tech().currentTime();
    }
  }

  showContentGatingIfPlayLimitExceeded() {
    this.storeInitialPlayerTime();

    if (this.playTimeElapsed() >= window.contentGatingActionRequiredAfter) {
      this.showBanner();
    }
  }

  playTimeElapsed() {
    return (window.player.tech().currentTime() - (this.initialPlayerTime || 0));
  }

  showBanner() {
    this.banner.show();

    Topic.publish('content_gating/banner/ready');
    this.sendBlockerEvent();
    this.disablePlayer();
  }

  sendBlockerEvent() {
    AhoyEvent.send('PLAYBACK::BLOCKER', {
      content_type: this.contentType,
      is_premier: KmklabsUtil.isPremium(),
      content_id: KmklabsUtil.videoId(),
      blocker_type: this.banner.type(),
    });
  }

  get contentType() {
    let controller = document.querySelector('body').getAttribute('data-controller');

    if(this._type == undefined && controller != null) {
      this._type = controller.includes('videos') ? 'vod' : 'livestreaming';
    }

    return this._type;
  }

  disablePlayer() {
    if(this._disposeIntervalId !== null) return;

    this._disposeIntervalId = setInterval(this.disposePlayer.bind(this), 100);
  }

  disposePlayer() {
    if(window.player && window.player.tech() && window.player.tech().plugin()) {
      window.player.tech().dispose();
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    } else if(this._disposeCounter == 100) {
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    }
    this._disposeCounter++;
  }
}